// Pathify
import { make } from 'vuex-pathify'
import axios from 'axios'
import auth from './authentification'
import message from './messages'

const state = {
  disasters: [],
  //affectedAssetList: []
}

const mutations = {
  setDisasters(state, payload) {
    state.disasters = payload;
  },
  /*setAffectedAssetList(state, payload) {
   state.affectedAssetList = payload;
  },*/
}

const actions = {
  getDisasters: ({ state, commit }) => {
    try{
      //axios.get(`http://localhost:3000/api/disasters`).then(response => {
      axios.get(`/api/disasters`).then(response => {
        commit('setDisasters', response.data);
      });
    } catch(error){
      commit('setDisasters', []);
    }
  },
  addDisaster: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      //axios.post(`http://localhost:3000/api/new_disaster`,payload).then(response => {
      axios.post(`/api/new_disaster`,payload).then(response => {
        message.mutations.setConfirmationAdd(message.state, true);
        dispatch('getDisasters');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setDisasters', []);
    }
  },
  updateDisaster: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      //axios.post(`http://localhost:3000/api/disasters`,payload).then(response => {
      axios.post(`/api/disasters`,payload).then(response => {
        message.mutations.setConfirmationUpdate(message.state, true);
        //commit('setDisasters', response.data);
        dispatch('getDisasters');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setDisasters', []);
    }
  },
  deleteDisaster: ({ state, commit, dispatch }, payload) => {
    try{

      var request = {
        id: payload,
        username : auth.state.username
      }

      //axios.post(`/api/delete_disaster`,{id: payload}).then(response => {
      axios.post(`/api/delete_disaster`,request).then(response => {
        message.mutations.setConfirmationDelete(message.state, true);
        dispatch('getDisasters');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setDisasters', []);
    }
  },
  /*getAffectedAssetList: ({ state, commit }, payload) => {
    try{
        axios.post(`/api/affected_assets_disaster`,payload).then(response => {

        console.log(response.data);
        //TO PUT ON SERVER SIDE AND COMPLETE WITH OTHER ASSET
        var affectedAssets = [];
        for(var i=0; i< response.data.length; i++){
          if(response.data[i].affected_road){
            var obj = {
              id: response.data[i].id,
              asset_number: response.data[i].affected_road.road_referential.asset_number,
              name_en: response.data[i].affected_road.road_referential.name_en,
              asset_type: response.data[i].asset_type.translation.name
            }
            affectedAssets.push(obj);
          }
        }

        commit('setAffectedAssetList', affectedAssets);
      });
    } catch(error){
      commit('setAffectedAssetList', []);
    }
  },*/

}

const getters = {
  disasters: state => {
    return state.disasters
  },
  /*affectedAssetList: state => {
    return state.affectedAssetList
  },*/
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
